import styled from 'styled-components';

export const Link = styled.a`
  color: inherit;
`;

export const ConditionTooltipContent = styled.div`
  min-width: 15rem;
`;
